/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class ProfileBannerItem extends Component {
  /** attrs **/
  // icon specifies a paper icon to display in the header.
  icon = '';

  // title specifies the title for the profile banner.
  title = '';
}
